// // src/services/api.js
// let apiConfig = {
//   apiKey: null,
//   apiSecret: null,
//   // apiUrl: 'https://coinleyserver-production.up.railway.app',
//   // apiUrl: 'https://hub.coinley.io',
//   apiUrl: 'http://localhost:9000',
//   merchantWalletAddresses: {},
//   authToken: null,
//   merchantFeePercentage: null,
//   merchantNetworks: [], // Add this to store merchant's configured networks
//   merchantTokens: [] // Add this to store merchant's supported tokens
// };

// /**
//  * Initialize the API with configuration
//  */
// export const initializeApi = async (config) => {
//   apiConfig = { ...apiConfig, ...config };
//   console.log('API initialized with:', {
//     apiUrl: apiConfig.apiUrl,
//     apiKey: apiConfig.apiKey ? `${apiConfig.apiKey.substring(0, 6)}...` : null,
//     hasWalletAddresses: Object.keys(apiConfig.merchantWalletAddresses || {}).length > 0
//   });

//   // Authenticate and fetch merchant data immediately
//   try {
//     await authenticateAndFetchMerchantData();
//   } catch (error) {
//     console.error('Failed to fetch merchant data during initialization:', error);
//   }
// };

// /**
//  * Authenticate with the API and fetch all merchant data (wallets, networks, tokens, fee)
//  */
// const authenticateAndFetchMerchantData = async () => {
//   try {
//     console.log('Authenticating and fetching merchant data...');
    
//     // Create a temporary auth token for API calls
//     const tempToken = btoa(`${apiConfig.apiKey}:${apiConfig.apiSecret}`);
    
//     // Fetch merchant networks and tokens from the new endpoint
//     const networksResponse = await fetch(`${apiConfig.apiUrl}/api/merchants/networks-and-tokens`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${tempToken}`,
//         'x-api-key': apiConfig.apiKey,
//         'x-api-secret': apiConfig.apiSecret
//       }
//     });

//     if (networksResponse.ok) {
//       const networksData = await networksResponse.json();
//       console.log('Merchant networks and tokens received:', networksData);
      
//       if (networksData.success) {
//         // Store merchant's configured networks and tokens with deduplication
//         const rawNetworks = networksData.networks || [];
//         const rawTokens = networksData.tokens || [];
        
//         console.log('Raw networks from backend:', rawNetworks);
//         console.log('Raw tokens from backend:', rawTokens);
        
//         // Remove duplicate networks based on shortName
//         const uniqueNetworks = rawNetworks.filter((network, index, self) => 
//           index === self.findIndex(n => n.shortName === network.shortName)
//         );
        
//         // Remove duplicate tokens based on symbol + networkId combination
//         const uniqueTokens = rawTokens.filter((token, index, self) => 
//           index === self.findIndex(t => 
//             t.symbol === token.symbol && 
//             t.networkId === token.networkId
//           )
//         );
        
//         console.log('Deduplicated networks:', uniqueNetworks);
//         console.log('Deduplicated tokens:', uniqueTokens);
        
//         apiConfig.merchantNetworks = uniqueNetworks;
//         apiConfig.merchantTokens = uniqueTokens;
//         apiConfig.merchantWalletAddresses = networksData.merchantWallets || {};
        
//         console.log('Merchant configured networks:', apiConfig.merchantNetworks.map(n => n.name));
//         console.log('Merchant supported tokens:', apiConfig.merchantTokens.map(t => `${t.symbol} (${t.Network?.name})`));
//         console.log('Merchant wallet addresses:', apiConfig.merchantWalletAddresses);
//       }
//     } else {
//       console.error('Failed to fetch merchant networks and tokens:', networksResponse.status);
//     }

//     // Also fetch merchant dashboard for fee percentage and other info
//     const dashboardResponse = await fetch(`${apiConfig.apiUrl}/api/merchants/dashboard`, {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': `Bearer ${tempToken}`,
//         'x-api-key': apiConfig.apiKey,
//         'x-api-secret': apiConfig.apiSecret
//       }
//     });

//     if (dashboardResponse.ok) {
//       const dashboardData = await dashboardResponse.json();
//       console.log('Merchant dashboard data received:', dashboardData);
      
//       if (dashboardData.merchant) {
//         // Get custom fee percentage
//         const customFeePercentage = dashboardData.merchant.customFeePercentage || 0.0175;
//         apiConfig.merchantFeePercentage = customFeePercentage;
        
//         console.log('Merchant fee percentage:', customFeePercentage);
        
//         // Merge any additional wallet addresses from dashboard
//         if (dashboardData.merchant.walletAddress) {
//           apiConfig.merchantWalletAddresses.ethereum = dashboardData.merchant.walletAddress;
//         }
        
//         if (dashboardData.merchant.solWalletAddress) {
//           apiConfig.merchantWalletAddresses.solana = dashboardData.merchant.solWalletAddress;
//         }
        
//         if (dashboardData.merchant.merchantWallets) {
//           Object.assign(apiConfig.merchantWalletAddresses, dashboardData.merchant.merchantWallets);
//         }
//       }
//     }
    
//     return {
//       networks: apiConfig.merchantNetworks,
//       tokens: apiConfig.merchantTokens,
//       walletAddresses: apiConfig.merchantWalletAddresses,
//       feePercentage: apiConfig.merchantFeePercentage
//     };
//   } catch (error) {
//     console.error('Error fetching merchant data:', error);
//     return {
//       networks: [],
//       tokens: [],
//       walletAddresses: {},
//       feePercentage: 0.0175
//     };
//   }
// };

// /**
//  * Get merchant's configured networks
//  */
// export const getMerchantNetworks = async () => {
//   // If we don't have networks, try to fetch them
//   if (apiConfig.merchantNetworks.length === 0) {
//     await authenticateAndFetchMerchantData();
//   }
  
//   return apiConfig.merchantNetworks;
// };

// /**
//  * Get merchant's supported tokens (optionally filtered by network)
//  */
// export const getMerchantTokens = async (networkShortName = null) => {
//   // If we don't have tokens, try to fetch them
//   if (apiConfig.merchantTokens.length === 0) {
//     await authenticateAndFetchMerchantData();
//   }
  
//   // Filter by network if specified
//   if (networkShortName) {
//     return apiConfig.merchantTokens.filter(token => 
//       token.Network && token.Network.shortName === networkShortName
//     );
//   }
  
//   return apiConfig.merchantTokens;
// };

// /**
//  * Get merchant wallet addresses (with fresh fetch if needed)
//  */
// export const getMerchantWallets = async () => {
//   // If we don't have wallet addresses, try to fetch them
//   if (Object.keys(apiConfig.merchantWalletAddresses).length === 0) {
//     await authenticateAndFetchMerchantData();
//   }
  
//   return apiConfig.merchantWalletAddresses;
// };

// /**
//  * Get merchant fee percentage
//  */
// export const getMerchantFeePercentage = async () => {
//   // If we don't have fee percentage, try to fetch it
//   if (apiConfig.merchantFeePercentage === null) {
//     const result = await authenticateAndFetchMerchantData();
//     return result.feePercentage;
//   }
  
//   return apiConfig.merchantFeePercentage;
// };

// /**
//  * Check if a network is supported by the merchant
//  */
// export const isMerchantNetworkSupported = async (networkShortName) => {
//   const networks = await getMerchantNetworks();
//   return networks.some(network => network.shortName === networkShortName);
// };

// /**
//  * Check if a token is supported by the merchant on a specific network
//  */
// export const isMerchantTokenSupported = async (tokenSymbol, networkShortName) => {
//   const tokens = await getMerchantTokens(networkShortName);
//   return tokens.some(token => 
//     token.symbol === tokenSymbol && 
//     token.Network && 
//     token.Network.shortName === networkShortName
//   );
// };

// /**
//  * Generate headers with authentication
//  */
// const getHeaders = () => {
//   return {
//     'Content-Type': 'application/json',
//     'x-api-key': apiConfig.apiKey,
//     'x-api-secret': apiConfig.apiSecret,
//     'Authorization': apiConfig.authToken ? `Bearer ${apiConfig.authToken}` : undefined
//   };
// };

// /**
//  * Create a new payment with proper wallet address resolution
//  */
// export const createPayment = async (paymentData) => {
//   try {
//     console.log('Creating payment with data:', paymentData);
    
//     if (!paymentData.amount) {
//       throw new Error('Payment amount is required');
//     }

//     // Ensure we have merchant data
//     const merchantWallets = await getMerchantWallets();
//     console.log('Using merchant wallets:', merchantWallets);
    
//     // Validate that the network and currency are supported by the merchant
//     const isNetworkSupported = await isMerchantNetworkSupported(paymentData.network);
//     if (!isNetworkSupported) {
//       throw new Error(`Network ${paymentData.network} is not configured for this merchant`);
//     }
    
//     const isTokenSupported = await isMerchantTokenSupported(paymentData.currency, paymentData.network);
//     if (!isTokenSupported) {
//       throw new Error(`Token ${paymentData.currency} is not supported on ${paymentData.network} network for this merchant`);
//     }
    
//     // Enhance payment data with merchant wallet addresses
//     const enhancedPaymentData = { 
//       ...paymentData,
//       merchantWalletAddresses: {
//         ...merchantWallets,
//         ...paymentData.merchantWalletAddresses
//       }
//     };
    
//     console.log('Enhanced payment data:', enhancedPaymentData);
    
//     const response = await fetch(`${apiConfig.apiUrl}/api/payments/create`, {
//       method: 'POST',
//       headers: getHeaders(),
//       body: JSON.stringify(enhancedPaymentData)
//     });

//     console.log('Create payment response status:', response.status);
    
//     if (!response.ok) {
//       let errorData;
//       try {
//         errorData = await response.json();
//       } catch (e) {
//         throw new Error(`Failed to create payment: ${response.status} ${response.statusText}`);
//       }
      
//       console.error('Error creating payment:', errorData);
//       throw new Error(errorData.error || `Failed to create payment: ${response.status}`);
//     }

//     const data = await response.json();
//     console.log('Payment created successfully:', data);
    
//     return data;
//   } catch (error) {
//     console.error('Create payment error:', error);
//     throw error;
//   }
// };

// /**
//  * Get payment details by ID
//  */
// export const getPayment = async (paymentId) => {
//   try {
//     console.log('Getting payment:', paymentId);
    
//     if (!paymentId) {
//       throw new Error('Payment ID is required');
//     }
    
//     const response = await fetch(`${apiConfig.apiUrl}/api/payments/${paymentId}`, {
//       method: 'GET',
//       headers: getHeaders()
//     });

//     if (!response.ok) {
//       let errorData;
//       try {
//         errorData = await response.json();
//       } catch (e) {
//         throw new Error(`Failed to get payment: ${response.status} ${response.statusText}`);
//       }
      
//       console.error('Error getting payment:', errorData);
//       throw new Error(errorData.error || `Failed to get payment: ${response.status}`);
//     }

//     const data = await response.json();
//     console.log('Get payment response:', data);
    
//     return data;
//   } catch (error) {
//     console.error('Get payment error:', error);
//     throw error;
//   }
// };

// /**
//  * Process a payment
//  */
// export const processPayment = async (processData) => {
//   try {
//     console.log('Processing payment with data:', processData);
    
//     if (!processData.paymentId) {
//       throw new Error('Payment ID is required');
//     }
    
//     if (!processData.transactionHash) {
//       throw new Error('Transaction hash is required');
//     }
    
//     const response = await fetch(`${apiConfig.apiUrl}/api/payments/process`, {
//       method: 'POST',
//       headers: getHeaders(),
//       body: JSON.stringify(processData)
//     });

//     console.log('Process payment response status:', response.status);
    
//     if (!response.ok) {
//       let errorData;
//       try {
//         errorData = await response.json();
//       } catch (e) {
//         throw new Error(`Failed to process payment: ${response.status} ${response.statusText}`);
//       }
      
//       console.error('Error processing payment:', errorData);
//       throw new Error(errorData.error || `Failed to process payment: ${response.status}`);
//     }

//     const data = await response.json();
//     console.log('Process payment response data:', data);
//     return data;
//   } catch (error) {
//     console.error('Process payment error:', error);
//     throw error;
//   }
// };

// /**
//  * Get supported networks and tokens (returns only merchant's configured ones)
//  */
// export const getSupportedNetworks = async () => {
//   try {
//     const networks = await getMerchantNetworks();
//     const tokens = await getMerchantTokens();
    
//     return {
//       success: true,
//       networks: networks,
//       tokens: tokens
//     };
//   } catch (error) {
//     console.error('Get supported networks error:', error);
//     throw error;
//   }
// };

// /**
//  * Get merchant payments with filters
//  */
// export const getMerchantPayments = async (options = {}) => {
//   try {
//     const queryParams = new URLSearchParams();
    
//     Object.entries(options).forEach(([key, value]) => {
//       if (value !== null && value !== undefined) {
//         queryParams.append(key, value);
//       }
//     });
    
//     const response = await fetch(`${apiConfig.apiUrl}/api/payments?${queryParams}`, {
//       method: 'GET',
//       headers: getHeaders()
//     });
    
//     if (!response.ok) {
//       let errorData;
//       try {
//         errorData = await response.json();
//       } catch (e) {
//         throw new Error(`Failed to get payments: ${response.status} ${response.statusText}`);
//       }
      
//       throw new Error(errorData.error || `Failed to get payments: ${response.status}`);
//     }
    
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error('Get merchant payments error:', error);
//     throw error;
//   }
// };

// /**
//  * Get payment statistics
//  */
// export const getMerchantPaymentStats = async () => {
//   try {
//     const response = await fetch(`${apiConfig.apiUrl}/api/payments/stats`, {
//       method: 'GET',
//       headers: getHeaders()
//     });
    
//     if (!response.ok) {
//       let errorData;
//       try {
//         errorData = await response.json();
//       } catch (e) {
//         throw new Error(`Failed to get payment stats: ${response.status} ${response.statusText}`);
//       }
      
//       throw new Error(errorData.error || `Failed to get payment stats: ${response.status}`);
//     }
    
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error('Get payment stats error:', error);
//     throw error;
//   }
// };

// /**
//  * Validate wallet address for specific network
//  */
// export const validateWalletAddress = async (address, network) => {
//   try {
//     const response = await fetch(`${apiConfig.apiUrl}/api/wallets/validate`, {
//       method: 'POST',
//       headers: getHeaders(),
//       body: JSON.stringify({ address, network })
//     });
    
//     if (!response.ok) {
//       let errorData;
//       try {
//         errorData = await response.json();
//       } catch (e) {
//         throw new Error(`Failed to validate address: ${response.status} ${response.statusText}`);
//       }
      
//       throw new Error(errorData.error || `Failed to validate address: ${response.status}`);
//     }
    
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error('Validate wallet address error:', error);
//     throw error;
//   }
// };

// /**
//  * Generate mock transaction hash for testing
//  */
// export const generateMockTransactionHash = (network = 'ethereum') => {
//   const prefixes = {
//     ethereum: '0x',
//     bsc: '0x',
//     tron: '',
//     algorand: ''
//   };
  
//   const prefix = prefixes[network] || '0x';
//   const hash = Array.from({length: 64}, () => 
//     Math.floor(Math.random() * 16).toString(16)).join('');
    
//   return `${prefix}${hash}`;
// };




// /**
//  * Verify QR code payment by checking blockchain for transactions
//  */
// export const verifyQRPayment = async (paymentId) => {
//   try {
//     console.log('Verifying QR payment:', paymentId);
    
//     if (!paymentId) {
//       throw new Error('Payment ID is required');
//     }
    
//     const response = await fetch(`${apiConfig.apiUrl}/api/payments/verify-qr`, {
//       method: 'POST',
//       headers: getHeaders(),
//       body: JSON.stringify({ paymentId })
//     });

//     console.log('Verify QR payment response status:', response.status);
    
//     if (!response.ok) {
//       let errorData;
//       try {
//         errorData = await response.json();
//       } catch (e) {
//         throw new Error(`Failed to verify payment: ${response.status} ${response.statusText}`);
//       }
      
//       console.error('Error verifying QR payment:', errorData);
//       throw new Error(errorData.error || `Failed to verify payment: ${response.status}`);
//     }

//     const data = await response.json();
//     console.log('QR payment verification response:', data);
    
//     return data;
//   } catch (error) {
//     console.error('QR payment verification error:', error);
//     throw error;
//   }
// };

// // Export the current config for debugging
// export const getApiConfig = () => apiConfig;









// src/services/api.js - Fixed version with better error handling
let apiConfig = {
  apiKey: null,
  apiSecret: null,
  apiUrl: 'https://hub.coinley.io',
  merchantWalletAddresses: {},
  authToken: null,
  merchantFeePercentage: null,
  merchantNetworks: [],
  merchantTokens: []
};

/**
 * Initialize the API with configuration
 */
export const initializeApi = async (config) => {
  apiConfig = { ...apiConfig, ...config };
  console.log('API initialized with:', {
    apiUrl: apiConfig.apiUrl,
    apiKey: apiConfig.apiKey ? `${apiConfig.apiKey.substring(0, 6)}...` : null,
    hasWalletAddresses: Object.keys(apiConfig.merchantWalletAddresses || {}).length > 0
  });

  // Authenticate and fetch merchant data immediately
  try {
    await authenticateAndFetchMerchantData();
  } catch (error) {
    console.error('Failed to fetch merchant data during initialization:', error);
    // Don't throw error here - allow SDK to continue with fallback data
  }
};

/**
 * Enhanced authentication with better error handling and fallbacks
 */
const authenticateAndFetchMerchantData = async () => {
  try {
    console.log('🔍 Authenticating and fetching merchant data...');
    
    // Create a temporary auth token for API calls
    const tempToken = btoa(`${apiConfig.apiKey}:${apiConfig.apiSecret}`);
    
    // 1. First try the combined endpoint
    try {
      const networksResponse = await fetch(`${apiConfig.apiUrl}/api/merchants/networks-and-tokens`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${tempToken}`,
          'x-api-key': apiConfig.apiKey,
          'x-api-secret': apiConfig.apiSecret
        }
      });

      if (networksResponse.ok) {
        const networksData = await networksResponse.json();
        console.log('✅ Merchant networks and tokens received:', networksData);
        
        if (networksData.success) {
          const rawNetworks = networksData.networks || [];
          const rawTokens = networksData.tokens || [];
          
          // Remove duplicates and filter out RLUSD
          const uniqueNetworks = rawNetworks.filter((network, index, self) => 
            index === self.findIndex(n => n.shortName === network.shortName)
          );
          
          const uniqueTokens = rawTokens.filter((token, index, self) => {
            // Filter out RLUSD tokens
            const isRLUSD = token.symbol?.toUpperCase() === 'RLUSD' ||
              token.name?.toLowerCase().includes('raft locked');
            
            return !isRLUSD && index === self.findIndex(t => 
              t.symbol === token.symbol && t.networkId === token.networkId
            );
          });
          
          apiConfig.merchantNetworks = uniqueNetworks;
          apiConfig.merchantTokens = uniqueTokens;
          apiConfig.merchantWalletAddresses = networksData.merchantWallets || {};
          
          console.log('✅ Successfully configured:', {
            networks: uniqueNetworks.length,
            tokens: uniqueTokens.length,
            wallets: Object.keys(networksData.merchantWallets || {}).length
          });
        }
      } else {
        console.warn('⚠️ Networks endpoint failed, trying fallback approach...');
        await fetchDataWithFallback(tempToken);
      }
    } catch (error) {
      console.warn('⚠️ Primary endpoint failed, trying fallback approach...', error.message);
      await fetchDataWithFallback(tempToken);
    }

    // 2. Also fetch merchant dashboard for fee percentage
    try {
      const dashboardResponse = await fetch(`${apiConfig.apiUrl}/api/merchants/dashboard`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${tempToken}`,
          'x-api-key': apiConfig.apiKey,
          'x-api-secret': apiConfig.apiSecret
        }
      });

      if (dashboardResponse.ok) {
        const dashboardData = await dashboardResponse.json();
        console.log('✅ Merchant dashboard data received');
        
        if (dashboardData.merchant) {
          // Get custom fee percentage
          const customFeePercentage = dashboardData.merchant.customFeePercentage || 0.0175;
          apiConfig.merchantFeePercentage = customFeePercentage;
          
          // Merge wallet addresses
          if (dashboardData.merchant.walletAddress) {
            apiConfig.merchantWalletAddresses.ethereum = dashboardData.merchant.walletAddress;
          }
          
          if (dashboardData.merchant.solWalletAddress) {
            apiConfig.merchantWalletAddresses.solana = dashboardData.merchant.solWalletAddress;
          }
          
          if (dashboardData.merchant.merchantWallets) {
            Object.assign(apiConfig.merchantWalletAddresses, dashboardData.merchant.merchantWallets);
          }
        }
      }
    } catch (error) {
      console.warn('⚠️ Dashboard endpoint failed:', error.message);
    }
    
    return {
      networks: apiConfig.merchantNetworks,
      tokens: apiConfig.merchantTokens,
      walletAddresses: apiConfig.merchantWalletAddresses,
      feePercentage: apiConfig.merchantFeePercentage
    };
  } catch (error) {
    console.error('❌ Error fetching merchant data:', error);
    return {
      networks: [],
      tokens: [],
      walletAddresses: {},
      feePercentage: 0.0175
    };
  }
};

/**
 * Fallback method to fetch data from individual endpoints
 */
const fetchDataWithFallback = async (tempToken) => {
  try {
    console.log('🔄 Using fallback data fetching...');
    
    // Try to get networks from general endpoint
    const networksResponse = await fetch(`${apiConfig.apiUrl}/api/networks`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (networksResponse.ok) {
      const networksData = await networksResponse.json();
      console.log('✅ Got networks from fallback endpoint:', networksData.networks?.length);
      
      // Use all available networks as fallback
      apiConfig.merchantNetworks = networksData.networks || [];
      
      // For each network, try to get tokens
      const allTokens = [];
      for (const network of apiConfig.merchantNetworks) {
        try {
          const tokensResponse = await fetch(`${apiConfig.apiUrl}/api/networks/${network.id}/tokens`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          });
          
          if (tokensResponse.ok) {
            const tokensData = await tokensResponse.json();
            const tokensWithNetwork = (tokensData.tokens || []).map(token => ({
              ...token,
              Network: network,
              networkId: network.id
            }));
            allTokens.push(...tokensWithNetwork);
          }
        } catch (error) {
          console.warn(`⚠️ Failed to get tokens for network ${network.name}:`, error.message);
        }
      }
      
      // Filter out RLUSD tokens
      apiConfig.merchantTokens = allTokens.filter(token => {
        const isRLUSD = token.symbol?.toUpperCase() === 'RLUSD' ||
          token.name?.toLowerCase().includes('raft locked');
        return !isRLUSD;
      });
      
      console.log('✅ Fallback data configured:', {
        networks: apiConfig.merchantNetworks.length,
        tokens: apiConfig.merchantTokens.length
      });
    }
  } catch (error) {
    console.error('❌ Fallback data fetching also failed:', error);
    // Provide minimal default configuration
    apiConfig.merchantNetworks = [
      { id: 1, name: 'Ethereum', shortName: 'ethereum', type: 'ethereum' },
      { id: 2, name: 'BSC', shortName: 'bsc', type: 'ethereum' }
    ];
    apiConfig.merchantTokens = [
      { 
        id: 1, 
        symbol: 'USDT', 
        name: 'Tether USD', 
        Network: { shortName: 'ethereum', name: 'Ethereum' },
        networkId: 1,
        isStablecoin: true
      },
      { 
        id: 2, 
        symbol: 'USDC', 
        name: 'USD Coin', 
        Network: { shortName: 'ethereum', name: 'Ethereum' },
        networkId: 1,
        isStablecoin: true
      }
    ];
  }
};

/**
 * Get merchant's configured networks with better error handling
 */
export const getMerchantNetworks = async () => {
  // If we don't have networks, try to fetch them
  if (apiConfig.merchantNetworks.length === 0) {
    console.log('🔄 No networks cached, fetching...');
    await authenticateAndFetchMerchantData();
  }
  
  // If still no networks, return at least basic ones
  if (apiConfig.merchantNetworks.length === 0) {
    console.warn('⚠️ No networks available, returning defaults');
    return [
      { id: 1, name: 'Ethereum', shortName: 'ethereum', type: 'ethereum' },
      { id: 2, name: 'BSC', shortName: 'bsc', type: 'ethereum' }
    ];
  }
  
  return apiConfig.merchantNetworks;
};

/**
 * Get merchant's supported tokens with better error handling
 */
export const getMerchantTokens = async (networkShortName = null) => {
  // If we don't have tokens, try to fetch them
  if (apiConfig.merchantTokens.length === 0) {
    console.log('🔄 No tokens cached, fetching...');
    await authenticateAndFetchMerchantData();
  }
  
  // If still no tokens, return at least basic ones
  if (apiConfig.merchantTokens.length === 0) {
    console.warn('⚠️ No tokens available, returning defaults');
    const defaultTokens = [
      { 
        id: 1, 
        symbol: 'USDT', 
        name: 'Tether USD', 
        Network: { shortName: 'ethereum', name: 'Ethereum' },
        networkId: 1,
        isStablecoin: true
      },
      { 
        id: 2, 
        symbol: 'USDC', 
        name: 'USD Coin', 
        Network: { shortName: 'ethereum', name: 'Ethereum' },
        networkId: 1,
        isStablecoin: true
      }
    ];
    
    // Filter by network if specified
    if (networkShortName) {
      return defaultTokens.filter(token => 
        token.Network && token.Network.shortName === networkShortName
      );
    }
    
    return defaultTokens;
  }
  
  // Filter by network if specified
  if (networkShortName) {
    return apiConfig.merchantTokens.filter(token => 
      token.Network && token.Network.shortName === networkShortName
    );
  }
  
  return apiConfig.merchantTokens;
};

// Keep all other existing functions unchanged...
export const getMerchantWallets = async () => {
  if (Object.keys(apiConfig.merchantWalletAddresses).length === 0) {
    await authenticateAndFetchMerchantData();
  }
  
  return apiConfig.merchantWalletAddresses;
};

export const getMerchantFeePercentage = async () => {
  if (apiConfig.merchantFeePercentage === null) {
    const result = await authenticateAndFetchMerchantData();
    return result.feePercentage;
  }
  
  return apiConfig.merchantFeePercentage;
};

// ... rest of the existing functions remain the same
export const isMerchantNetworkSupported = async (networkShortName) => {
  const networks = await getMerchantNetworks();
  return networks.some(network => network.shortName === networkShortName);
};

export const isMerchantTokenSupported = async (tokenSymbol, networkShortName) => {
  const tokens = await getMerchantTokens(networkShortName);
  return tokens.some(token => 
    token.symbol === tokenSymbol && 
    token.Network && 
    token.Network.shortName === networkShortName
  );
};

const getHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'x-api-key': apiConfig.apiKey,
    'x-api-secret': apiConfig.apiSecret,
    'Authorization': apiConfig.authToken ? `Bearer ${apiConfig.authToken}` : undefined
  };
};

export const createPayment = async (paymentData) => {
  try {
    console.log('Creating payment with data:', paymentData);
    
    if (!paymentData.amount) {
      throw new Error('Payment amount is required');
    }

    // Ensure we have merchant data
    const merchantWallets = await getMerchantWallets();
    console.log('Using merchant wallets:', merchantWallets);
    
    // Validate that the network and currency are supported by the merchant
    const isNetworkSupported = await isMerchantNetworkSupported(paymentData.network);
    if (!isNetworkSupported) {
      throw new Error(`Network ${paymentData.network} is not configured for this merchant`);
    }
    
    const isTokenSupported = await isMerchantTokenSupported(paymentData.currency, paymentData.network);
    if (!isTokenSupported) {
      throw new Error(`Token ${paymentData.currency} is not supported on ${paymentData.network} network for this merchant`);
    }
    
    // Enhance payment data with merchant wallet addresses
    const enhancedPaymentData = { 
      ...paymentData,
      merchantWalletAddresses: {
        ...merchantWallets,
        ...paymentData.merchantWalletAddresses
      }
    };
    
    console.log('Enhanced payment data:', enhancedPaymentData);
    
    const response = await fetch(`${apiConfig.apiUrl}/api/payments/create`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(enhancedPaymentData)
    });

    console.log('Create payment response status:', response.status);
    
    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        throw new Error(`Failed to create payment: ${response.status} ${response.statusText}`);
      }
      
      console.error('Error creating payment:', errorData);
      throw new Error(errorData.error || `Failed to create payment: ${response.status}`);
    }

    const data = await response.json();
    console.log('Payment created successfully:', data);
    
    return data;
  } catch (error) {
    console.error('Create payment error:', error);
    throw error;
  }
};

// Keep all other existing functions...
export const getPayment = async (paymentId) => {
  try {
    console.log('Getting payment:', paymentId);
    
    if (!paymentId) {
      throw new Error('Payment ID is required');
    }
    
    const response = await fetch(`${apiConfig.apiUrl}/api/payments/${paymentId}`, {
      method: 'GET',
      headers: getHeaders()
    });

    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        throw new Error(`Failed to get payment: ${response.status} ${response.statusText}`);
      }
      
      console.error('Error getting payment:', errorData);
      throw new Error(errorData.error || `Failed to get payment: ${response.status}`);
    }

    const data = await response.json();
    console.log('Get payment response:', data);
    
    return data;
  } catch (error) {
    console.error('Get payment error:', error);
    throw error;
  }
};

export const processPayment = async (processData) => {
  try {
    console.log('Processing payment with data:', processData);
    
    if (!processData.paymentId) {
      throw new Error('Payment ID is required');
    }
    
    if (!processData.transactionHash) {
      throw new Error('Transaction hash is required');
    }
    
    const response = await fetch(`${apiConfig.apiUrl}/api/payments/process`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(processData)
    });

    console.log('Process payment response status:', response.status);
    
    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        throw new Error(`Failed to process payment: ${response.status} ${response.statusText}`);
      }
      
      console.error('Error processing payment:', errorData);
      throw new Error(errorData.error || `Failed to process payment: ${response.status}`);
    }

    const data = await response.json();
    console.log('Process payment response data:', data);
    return data;
  } catch (error) {
    console.error('Process payment error:', error);
    throw error;
  }
};

export const verifyQRPayment = async (paymentId) => {
  try {
    console.log('Verifying QR payment:', paymentId);
    
    if (!paymentId) {
      throw new Error('Payment ID is required');
    }
    
    const response = await fetch(`${apiConfig.apiUrl}/api/payments/verify-qr`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ paymentId })
    });

    console.log('Verify QR payment response status:', response.status);
    
    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        throw new Error(`Failed to verify payment: ${response.status} ${response.statusText}`);
      }
      
      console.error('Error verifying QR payment:', errorData);
      throw new Error(errorData.error || `Failed to verify payment: ${response.status}`);
    }

    const data = await response.json();
    console.log('QR payment verification response:', data);
    
    return data;
  } catch (error) {
    console.error('QR payment verification error:', error);
    throw error;
  }
};

export const getSupportedNetworks = async () => {
  try {
    const networks = await getMerchantNetworks();
    const tokens = await getMerchantTokens();
    
    return {
      success: true,
      networks: networks,
      tokens: tokens
    };
  } catch (error) {
    console.error('Get supported networks error:', error);
    throw error;
  }
};

// Export the current config for debugging
export const getApiConfig = () => apiConfig;

// ✅ ADDED: Missing functions that were referenced in index.js
export const validateWalletAddress = async (address, network) => {
  try {
    const response = await fetch(`${apiConfig.apiUrl}/api/wallets/validate`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ address, network })
    });
    
    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        throw new Error(`Failed to validate address: ${response.status} ${response.statusText}`);
      }
      
      throw new Error(errorData.error || `Failed to validate address: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Validate wallet address error:', error);
    throw error;
  }
};

export const generateMockTransactionHash = (network = 'ethereum') => {
  const prefixes = {
    ethereum: '0x',
    bsc: '0x',
    tron: '',
    algorand: ''
  };
  
  const prefix = prefixes[network] || '0x';
  const hash = Array.from({length: 64}, () => 
    Math.floor(Math.random() * 16).toString(16)).join('');
    
  return `${prefix}${hash}`;
};

export const getMerchantPayments = async (options = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    Object.entries(options).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        queryParams.append(key, value);
      }
    });
    
    const response = await fetch(`${apiConfig.apiUrl}/api/payments?${queryParams}`, {
      method: 'GET',
      headers: getHeaders()
    });
    
    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        throw new Error(`Failed to get payments: ${response.status} ${response.statusText}`);
      }
      
      throw new Error(errorData.error || `Failed to get payments: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Get merchant payments error:', error);
    throw error;
  }
};

export const getMerchantPaymentStats = async () => {
  try {
    const response = await fetch(`${apiConfig.apiUrl}/api/payments/stats`, {
      method: 'GET',
      headers: getHeaders()
    });
    
    if (!response.ok) {
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        throw new Error(`Failed to get payment stats: ${response.status} ${response.statusText}`);
      }
      
      throw new Error(errorData.error || `Failed to get payment stats: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Get payment stats error:', error);
    throw error;
  }
};